import React from 'react';
import { NavLink } from 'react-router-dom';
import profile from '../../images/Unknownperson.gif';
import {RiDashboardFill} from 'react-icons/ri';
import {BsCalendarCheck} from 'react-icons/bs';
import {MdOutlineBedroomParent} from 'react-icons/md';
import {MdRateReview} from 'react-icons/md';
import {MdOutlineContactPage} from 'react-icons/md';
import {TiSocialTwitter} from 'react-icons/ti';
import {MdOutlinePermMedia} from 'react-icons/md';
import {AiFillMessage} from 'react-icons/ai';

import './CmsSidebar.css';
import { NavDropdown } from 'react-bootstrap';

function CmsSidebar(props) {
    return (
        <div>
            <div className={props.isOpen?'sidebarWrapper':'reducedSidebar'}>
                <div className={props.isOpen?'profilWrapper':'profilWrapperReduced'}>
                    <img src={profile} alt='profil'  />
                    <h3 style={{textAlign:'center',color:'#fff',padding:'10px'}}>Admin</h3>
                </div>
                <hr style={{color:'#fff'}} />
                <div className={props.isOpen?'sideNav':'reducedSidebar'}>
                    <NavLink to='/admin/dashboard' className={props.isOpen?'Navlink':'NavlinkReduced'}><RiDashboardFill aria-label='Dashboard'  /> <span className={props.isOpen?'titles':'titlesReduced'} >Dashboard</span> </NavLink>
                    <NavLink to='/admin/booking' className={props.isOpen?'Navlink':'NavlinkReduced'}><BsCalendarCheck /> <span className={props.isOpen?'titles':'titlesReduced'} >Bookings</span> </NavLink>
                    <NavLink to='/admin/room' className={props.isOpen?'Navlink':'NavlinkReduced'}><MdOutlineBedroomParent /> <span className={props.isOpen?'titles':'titlesReduced'} >Rooms</span> </NavLink>
                    <NavLink to='/admin/pagemanagement' className={props.isOpen?'Navlink':'NavlinkReduced'}><MdOutlineContactPage /> <span className={props.isOpen?'titles':'titlesReduced'} >Pages</span></NavLink>
                    <NavLink to='/admin/medias' className={props.isOpen?'Navlink':'NavlinkReduced'}><MdOutlinePermMedia /> <span className={props.isOpen?'titles':'titlesReduced'} >Media</span></NavLink>
                    <NavLink to='/admin/reviews' className={props.isOpen?'Navlink':'NavlinkReduced'}><MdRateReview /> <span className={props.isOpen?'titles':'titlesReduced'} >Reviews</span> </NavLink>
                    <NavLink to='/admin/messages' className={props.isOpen?'Navlink':'NavlinkReduced'}><AiFillMessage /> <span className={props.isOpen?'titles':'titlesReduced'} >Message</span></NavLink>
                    <NavLink to='/admin/sociallinks' className={props.isOpen?'Navlink':'NavlinkReduced'}><TiSocialTwitter /> <span className={props.isOpen?'titles':'titlesReduced'} >Social Links</span></NavLink>
                    {/* <NavDropdown title="Pages" id="basic-nav-dropdown">
                        <NavDropdown.Item href="#action/3.1">Action</NavDropdown.Item>
                        <NavDropdown.Item href="#action/3.2">Another action</NavDropdown.Item>
                        <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item>
                        <NavDropdown.Divider />
                        <NavDropdown.Item href="#action/3.4">Separated link</NavDropdown.Item>
                    </NavDropdown> */}
                    
                </div>
            </div>
           
        </div>
    )
}

export default CmsSidebar
